import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["commentsButton"]

  connect() {
    // Listen for sidebar events
    this.element.addEventListener("comments-sidebar:opened", this.handleSidebarOpened.bind(this))
    this.element.addEventListener("comments-sidebar:closed", this.handleSidebarClosed.bind(this))
  }



  toggleCommentsSidebar() {
    // Find the comments sidebar controller and open it
    const previewContainer = document.querySelector('[data-controller="comments-sidebar"]')
    if (previewContainer) {
      const controller = this.application.getControllerForElementAndIdentifier(
        previewContainer,
        'comments-sidebar'
      )
      if (controller) {
        controller.openSidebar()
      }
    }
  }

  handleSidebarOpened() {
    // Hide comments button when sidebar is opened
    if (this.hasCommentsButtonTarget) {
      this.commentsButtonTarget.classList.add("hidden")
    }
  }

  handleSidebarClosed() {
    // Show comments button when sidebar is closed
    if (this.hasCommentsButtonTarget) {
      this.commentsButtonTarget.classList.remove("hidden")
    }
  }


}
